import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuditLogService } from './audit-log.service';
import { environment } from 'environments/environment';
import { map, take } from 'rxjs/operators';
import { LocalStorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root'
})

export class BaseService {

  private baseUrl: string = environment.apiUrlV1;
  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    private auditLogService: AuditLogService
  ) { }

  getApi<T>({ methodPath }: { methodPath: string; }, options: { headers?: HttpHeaders; params?: HttpParams; responseType?: "json" }): Observable<T> {
    return this.http.get<T>(this.baseUrl + methodPath, options).pipe(
      take(1),
      map(response => {
        // const encryptedData = this.encrption.Encrypt(JSON.stringify(response));
        // const decryptedData = this.encrption.Decrypt(response);
        // console.log('Encrypted data:', encryptedData);
        // console.log('Decrypted data:', decryptedData);
        return response;
      })
    );
  }


  postApi<T>(methodPath: string, body?: string | FormData, headers?: HttpHeaders, params?: HttpParams): Observable<T> {
    let apiResponse!: Observable<T>;
    headers = this.setHeaderData(typeof (body), headers ?? new HttpHeaders())
    apiResponse = this.http.post<T>(this.baseUrl + methodPath, body, { headers, params }).pipe(take(1));
    return apiResponse;
  }

  setHeaderData(type: string, headers: HttpHeaders): HttpHeaders {
    let screenId: number = parseInt(this.localStorageService.getLocalData('taskId'));
    if (type === 'string')
      headers = headers.append('content-type', 'application/json');
    headers = headers.append('ScreenId', JSON.stringify(screenId));
    this.auditLogService.auditInformation$.subscribe(activityName => {
      if (activityName) {
        headers = headers.append('Activity', activityName);
      }
    });
    return headers;
  }
}

